<div *ngIf="contactForm" class="modal-content">
  <div class="modal-header justify-content-center">
    <h5 class="modal-title">{{ isNew ? 'Add' : 'Edit' }} Customer Contact</h5>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-10">
        <form role="form" [formGroup]="contactForm">
          <div class="form-group">
            <label class="control-label">First Name*</label>
            <input type="text" class="form-control" formControlName="firstName" lpValidationMsg/>
          </div>
          <div class="form-group">
            <label class="control-label">Last Name*</label>
            <input type="text" class="form-control" formControlName="lastName" lpValidationMsg/>
          </div>
          <div class="form-group">
            <label class="control-label">Email*</label>
            <input type="email" class="form-control" formControlName="email" lpValidationMsg/>
          </div>
          <div class="form-group">
            <label class="control-label">Email Recipient</label>
              <ng-select formControlName="emailRecipientType" placeholder="Select email recipient type"
                [items]="emailRecipientOptions" [clearable]="false" [searchable]="false">
                <ng-template ng-label-tmp let-item="item">
                  {{ item | emailRecipientType }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item | emailRecipientType }}
                </ng-template>
              </ng-select>
          </div>
          <div class="form-group">
            <label class="control-label">Phone</label>
            <input type="text" class="form-control" formControlName="phone" lpValidationMsg/>
          </div>
          <ng-container *ngIf="allowTextMessages">
            <div class="form-group">
              <label class="control-label me-1">Can Receive Texts</label>
              <shared-components-customchoice formControlName="canReceiveTextMessages"></shared-components-customchoice>
              <app-components-helptext [key]="'CustomerUser_CanReceiveTextMessages'"></app-components-helptext>
            </div>
          </ng-container>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-between">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="!contactForm.valid" (click)="activeModal.close(contactForm.value)">{{ isNew ? 'Add' : 'Update' }}</button>
  </div>
</div>